import { render, staticRenderFns } from "./MshipsModals.vue?vue&type=template&id=6137542f"
import script from "./MshipsModals.vue?vue&type=script&lang=js"
export * from "./MshipsModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports